import OwnerModel from '../owner/owner-model';
import ReportModel from '../report/report-model';

export default class ReportgroupModel {
    id: number;
    name: string;
    description: string;
    status: string;
    owner: any;
    ownerCaption: string;
    report: any;
    reportCaption: string;
    reportLength: number;

    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        let owner = datarow.owner?.data? new OwnerModel(datarow.owner?.data) : datarow.owner;
        this.owner = owner?.id;
        this.ownerCaption = owner?.name;
        this.report = datarow.report?.data?.map((d: any) => new ReportModel(d));
        this.reportLength = this.report?.length || 0;
        this.reportCaption = this.reportLength===0? '' : this.report?.[0]?.name + (this.reportLength>1? ', ...' : '');       
   } 

    public static endPoint: string = 'report-groups' 
    public static endPointFilterList = () => {
       const owner = OwnerModel.getOwner();
        return ( '?populate=*&sort=name&filters[owner]=' +owner);
    } 
    public static url: string = '/reportgroup';
    public static caption: string = 'Report Group';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active',
        owner: +OwnerModel.getOwner(),
        ownerCaption: OwnerModel.getOwnerCaption(),   
        report: [],
        reportCaption: '',
        reportLength: 0,
        }
    }
    
    public static validations = [
        { name: 'name', required: true, minLength: 3 },
        { name: 'description', minLength: 3 },
    ]

    public static columns = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'status', caption: ' ', type: 'state', default: 'active' },
    ]

    public static columnPicklist = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
    
}